(ns practitest.frontend.landing.events
  (:require [ajax.core :as ajax]
            [practitest.frontend.events :as events]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.components.notifications :as notifications]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]
            [re-frame.core :as re-frame]))

(def ^:const whats-new-cards-url
  "https://s3.amazonaws.com/pt_public/assets/app/marketing/whats_new_cards.json")

;; Initialize landing page - fetch all required data
(re-frame/reg-event-fx
 :landing/init
 (fn [{:keys [db]} _]
   (let [account-id (subs/get-current-account-id db)]
     {:db (assoc-in db [:landing :loading?] true)
      :fx [[:dispatch [:landing/fetch-account-info account-id]]
           [:dispatch [:landing/fetch-account-message account-id]]
           [:dispatch [:landing/fetch-projects]]
           [:dispatch [:landing/fetch-assigned-items]]
           [:dispatch [:landing/fetch-histories]]
           [:dispatch [:landing/fetch-whats-new]]]})))

(re-frame/reg-event-fx
 :landing/fetch-account-info
 (fn [_ [_ account-id]]
   {:http-xhrio {:method          :get
                 :uri             (broutes/get-url "landing#account_info" {:account_id account-id})
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success      [:landing/account-info-loaded]
                 :on-failure      [:landing/load-failed]}}))

(re-frame/reg-event-db
 :landing/account-info-loaded
 (fn [db [_ response]]
   (-> db
       (assoc-in [:landing :account] (:account response)))))

(re-frame/reg-event-fx
 :landing/fetch-account-message
 (fn [_ [_ account-id]]
   {:http-xhrio {:method          :get
                 :uri             (broutes/get-url "landing#account_message" {:account_id account-id})
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success      [:landing/account-message-loaded]
                 :on-failure      [:landing/load-failed]}}))

(re-frame/reg-event-db
 :landing/account-message-loaded
 (fn [db [_ response]]
   (-> db
       (assoc-in [:landing :account-message] (:message response))
       (assoc-in [:landing :display-account-message] (:display response)))))

(re-frame/reg-event-fx
 :landing/load-failed
 (fn [{:keys [db]} [_ error]]
   {:db (assoc-in db [:landing :loading?] false)
    :dispatch [::notifications/error2
               (get-translation "landing.error.load-failed" "Failed to load landing page data. Please try again.")]}))

(re-frame/reg-event-fx
 :landing/fetch-projects
 (fn [{:keys [db]} _]
   (let [account-id (subs/get-current-account-id db)]
     {:http-xhrio {:method          :get
                   :uri             (broutes/get-url "landing#projects" {:account_id account-id})
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [:landing/projects-loaded]
                   :on-failure      [:landing/projects-load-failed]}})))

(re-frame/reg-event-db
 :landing/projects-loaded
 (fn [db [_ response]]
   (-> db
       (assoc-in [:landing :all-projects] (:projects response))
       (assoc-in [:landing :projects-page] 1)
       (assoc-in [:landing :loading?] false))))

(re-frame/reg-event-fx
 :landing/projects-load-failed
 (fn [{:keys [db]} [_ error]]
   {:db db
    :dispatch [::events/api-error :landing/projects-load-failed
               {:message (get-translation "landing.projects.load-error" (str "Error loading projects" error))}]}))

(re-frame/reg-event-db
 :landing/change-projects-page
 (fn [db [_ page]]
   (assoc-in db [:landing :projects-page] page)))

(re-frame/reg-event-fx
 :landing/fetch-assigned-items
 (fn [{:keys [db]} _]
   (let [account-id (subs/get-current-account-id db)]
     {:http-xhrio {:method          :get
                   :uri             (broutes/get-url "landing#assigned_items" {:account_id account-id})
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [:landing/assigned-items-loaded]
                   :on-failure      [:landing/assigned-tems-load-failed]}})))

(re-frame/reg-event-db
 :landing/assigned-items-loaded
 (fn [db [_ response]]
   (assoc-in db [:landing :assigned-items] response)))

(re-frame/reg-event-fx
  :landing/assigned-tems-load-failed
  (fn [{:keys [db]} [_ error]]
    {:db db
     :dispatch [::events/api-error :landing/assigned-tems-load-failed
                {:message (get-translation "landing.assigned-items.load-error" "Error loading assigned items")}]}))

(re-frame/reg-event-fx
 :landing/fetch-histories
 (fn [{:keys [db]} _]
   (let [account-id (subs/get-current-account-id db)]
     {:http-xhrio {:method          :get
                   :uri             (broutes/get-url "landing#histories" {:account_id account-id})
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [:landing/histories-loaded]
                   :on-failure      [:landing/histories-load-failed]}})))

(re-frame/reg-event-db
 :landing/histories-loaded
 (fn [db [_ response]]
   (-> db
       (assoc-in [:landing :all-histories] (:histories response))
       (assoc-in [:landing :histories-page] 1))))

(re-frame/reg-event-fx
 :landing/histories-load-failed
 (fn [{:keys [db]} [_ error]]
   {:db db
    :dispatch [::events/api-error :landing/histories-load-failed
               {:message (get-translation "landing.histories.load-error" "Error loading histories")}]}))

(re-frame/reg-event-db
 :landing/change-histories-page
 (fn [db [_ page]]
   (assoc-in db [:landing :histories-page] page)))

(re-frame/reg-event-fx
 :landing/fetch-whats-new
 (fn [_ _]
   {:http-xhrio {:method          :get
                 :uri             whats-new-cards-url
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success      [:landing/whats-new-loaded]
                 :on-failure      [:landing/whats-new-load-failed]}}))

(re-frame/reg-event-db
 :landing/whats-new-loaded
 (fn [db [_ response]]
   ;; S3 returns object with numeric keys {"1": {...}, "2": {...}}
   ;; Convert to sorted list of cards
   (let [cards (->> response
                    (sort-by (comp js/parseInt name first))
                    (map second))]
     (assoc-in db [:landing :whats-new] cards))))

(re-frame/reg-event-fx
 :landing/whats-new-load-failed
 (fn [{:keys [db]} [_ _error]]
   {:db (assoc-in db [:landing :whats-new] [])
    :dispatch [::notifications/error2
               (get-translation "landing.whats-new.load-error" "Error loading what's new")]}))